import { IAdFoxBannerContext } from '@cian/adfox';
import * as React from 'react';

import { Adfox } from '../adfox/adfox';
import { adfoxMediaConstants } from '../adfox/constants';
import { MediaBanner } from '../media_banner/media_banner';

import { HeroContainer } from '../../../shared/containers/HeroContainer';
import { RegionalBackgroundContainer } from '../../../shared/containers/RegionalBackgroundContainer';
import { Marquee } from './Marquee';
import { mergeStyles } from '@cian/utils';

const s = require('./filters_block.css');

const backgrounds: IBackgrounds = {
  index: s['c-filters-bg_home'],
  'daily-rent': s['c-filters-bg_daily-rent'],
  commercial: s['c-filters-bg_commercial'],
  sale: s['c-filters-bg_sale'],
  rent: s['c-filters-bg_rent'],
  'new-buildings': s['c-filters-bg_new-buildings'],
};

export interface IBackgrounds {
  [Identifier: string]: string;
}

interface IProps {
  section: string;
  backgroundImageUrl?: string;
  backgroundShown: boolean;
  onLoadAdfox?(context: IAdFoxBannerContext): void;
  onBannerLinkClick?(context: IAdFoxBannerContext): void;
  mediaInfoText?: string;
  mediaNote?: string;
  isExperimentsLoading: boolean;
  isNewFilters: boolean;
}

interface IState {
  defaultImageUrl: string;
}

export class FiltersBlock extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = { defaultImageUrl: backgrounds[props.section] };
  }

  public render() {
    const { isNewFilters } = this.props;

    return (
      <div
        {...mergeStyles(
          s['c-filters'],
          !this.props.backgroundShown && s['c-filters-transparent'],
          isNewFilters && s['c-filters--new'],
        )}
      >
        <div className={s['c-filters-content']}>
          <div className={s['c-filters-inner']}>
            {isNewFilters && <HeroContainer />}
            {!isNewFilters && this.props.children}
            <Marquee mediaNote={this.props.mediaNote} hasNewPlacement={isNewFilters} />
          </div>
          {!this.props.isExperimentsLoading && (
            <Adfox
              constants={adfoxMediaConstants}
              section={this.props.section}
              banner={(context: IAdFoxBannerContext) => (
                <MediaBanner
                  {...context}
                  hasNewPlacement={isNewFilters}
                  infoText={this.props.mediaInfoText}
                  onLinkClick={() => this.props.onBannerLinkClick && this.props.onBannerLinkClick(context)}
                  onDidMount={() => this.props.onLoadAdfox && this.props.onLoadAdfox(context)}
                />
              )}
              failureBanner={(error: Error) => (
                <MediaBanner
                  hasNewPlacement={isNewFilters}
                  infoText={this.props.mediaInfoText}
                  onDidMount={() =>
                    this.props.onLoadAdfox &&
                    this.props.onLoadAdfox({
                      newBuildingId: '',
                      isApartment: '',
                    })
                  }
                />
              )}
            />
          )}
        </div>
        <div className={s['c-filters-content-overlay']}></div>
        {isNewFilters && this.props.backgroundShown && !this.props.backgroundImageUrl && (
          <RegionalBackgroundContainer />
        )}
        {(!isNewFilters || !!this.props.backgroundImageUrl) && (
          <div
            className={`${s['c-filters-bg']} ${this.state.defaultImageUrl}`}
            style={{
              // stylelint-disable
              backgroundImage: this.props.backgroundImageUrl ? `url(${this.props.backgroundImageUrl})` : '',
              // stylelint-enable
            }}
          />
        )}
      </div>
    );
  }
}
